import { Controller } from "stimulus"

export class FormValidationController extends Controller {
  disconnect() {
    this.validatableInputs.forEach((input) => input.removeEventListener(this.eventForInputType[`${input.type}`], this.validate))
    this.element.removeEventListener('submit', this.validateAll)
  }

  bindForm() {
    this.element.addEventListener('submit', this.validateAll.bind(this))
  }

  bindInputs() {
    let inputs = this.element.querySelectorAll('input')
    inputs.forEach((input) => {
      if (input.getAttribute('type') === 'hidden') return

      let input_name = this.declaredKey(input)
      if (!input_name) {
        input_name = input.getAttribute('id')
        if (!input_name) return

        input_name = input_name.replace(/_true/g, '').replace(/_false/g, '')
                               .replace(/_female/g, '').replace(/_male/g, '')
                               .replace(/_(\d+)/g, '')
      }

      if (this.validation.validatable(input_name)) {
        input.addEventListener(this.eventForInputType[`${input.type}`], this.validate.bind(this))
        this.validatableInputs.push(input)
      }
    })
  }

  bindSelects() {
    let selects = this.element.querySelectorAll('select')
    selects.forEach((select) => {
      let input_name = this.declaredKey(select)
      if (!input_name) {
        input_name = select.getAttribute('id')
        if (!input_name) return

        input_name = input_name.replace(/_(\d+)/g, '')
      }

      if (this.validation.validatable(input_name)) {
        select.addEventListener(this.eventForInputType['select'], this.validate.bind(this))
        this.validatableInputs.push(select)
      }
    })
  }

  // Los formularios de campos dinamicos no pueden derivar la llave del id del DOM (el id trae el
  // indice del nested attribute), asi que la declaran explicitamente en el input.
  declaredKey(element) {
    return element.dataset.validationKey || null
  }

  validationKey(element) {
    return this.declaredKey(element) ||
           element.getAttribute('id').replace(/_(\d+)/, '')
                  .replace(/_true/g, '').replace(/_false/g, '')
                  .replace(/_female/g, '').replace(/_male/g, '')
  }

  inputValue(input) {
    if(input.type === 'radio' || input.type === 'checkbox'){
      return this.handleCheckeable(input) ? input.value : ''
    } else {
      return input.value
    }
  }

  handleCheckeable(input) {
    const nodes = Array.from(input.closest('fieldset').querySelectorAll(`input[type=${input.type}]`))
    const checked = nodes.some(n => n.checked)
    return checked
  }

  validForm() {
    let valid = Object.values(this.errors).some((value) => value)
    return !valid
  }

  validateAll(event) {
    this.validatableInputs.forEach((input) => this.validate({ target: input }))
    if (!this.validForm()) {
      event.preventDefault()
      event.stopPropagation()

      // scrollIntoView no funciona sobre el input directamente
      const firstInvalid = document.querySelector('select.invalid, input.invalid')
      if (firstInvalid) firstInvalid.parentNode.scrollIntoView(false)

      // El boton de envio puede vivir fuera del form (atributo form="..."), no solo dentro
      let submit = event.target.querySelector('[type="submit"]') ||
                   document.querySelector(`[type="submit"][form="${event.target.id}"]`)
      if (submit) submit.disabled = false
    }
  }

  validate(event) {
    const target = event.target
    let inputValue = this.inputValue(target)
    let inputId = this.validationKey(target)
    // El slot de error se lleva por input, no por llave: dos contactos comparten
    // issue_contact_mobile_phone y uno valido borraria el error del otro.
    const errorKey = target.getAttribute('id') || inputId

    let validationResult = this.validation.validate(inputValue, inputId, this.newRecord, target)

    let validator = validationResult.find((validator) => !validator.result.valid)
    this.errors[errorKey] = !!validator
    this.render(target, validationResult)

    if(typeof(validator) === 'undefined' && inputId.includes('prospect')) {
      validationResult = this.validation.validate(inputValue, inputId.replace('prospect', 'user'), this.newRecord, target)
      validator = validationResult.find((validator) => !validator.result.valid)
      this.errors[errorKey] = !!validator
      this.render(target, validationResult)
    }
  }

  render(target, validation) {
    console.log('Implement me!')
  }
}
